export const article = {
  id: 9,
  title: "মানুষের জীবনে মৃত্যুর ভূমিকা",
  slug: "manusher-jibone-mrityur-bhumika",
  date: "October 30, 2025",
  excerpt: "মৃত্যুর অনিবার্যতা ও জীবনের অর্থের অনুসন্ধানকে কেন্দ্র করে সামাজিক ও মনস্তাত্ত্বিক এক ভাবনা।",
  content: `![Isle of the Dead](https://s3.ap-south-1.amazonaws.com/sourovroy.me-content/blogs/images/isle_of_death.jpg)

*Isle of the Dead: "Basel" version, 1880*

<div style="display: flex; justify-content: center;">
<div style="text-align: left; font-weight: bold;">

**পাষান ভূধরে,&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ঝরে নির্ঝরে,**  
**মৃত্যু;&nbsp;&nbsp;&nbsp;&nbsp;বিভীষিকা।**  
**ব্যথিত মরমে;&nbsp;&nbsp;আনে অঝোরে,**  
**চোখের&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;কণিকা।**  
**আমি ডিঙি বাই, যেই নদী ধরে,**  
**আদি অন্ত&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;নাই।**  
**এক মুখে তরী;&nbsp;ঢেউ ভরা নীরে,**  
**নাই কোথা&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ঠাঁই।**  
**অজানা আকাশ, গ্রহতারা কত,**  
**গৃহহীন&nbsp;&nbsp;আমি একা।**  
**ফোঁসে রূষ্ট ঝর্ণা;&nbsp;&nbsp;উত্তাল স্রোত,**  
**নয় কি&nbsp;&nbsp;স্বপন দেখা?**  
**মনে মনে ভাবি,&nbsp;&nbsp;ঘুম যাবে ভাঙি,**  
**বসে আমি গান গাই।**  
**স্রোতে টলমল, আবার এ ডিঙি,**  
**না! স্বপ্নের লেশ নাই!**  
**কৌতূহল আর সংশয়, আঁধারে,**  
**থামে সব&nbsp;&nbsp;&nbsp;&nbsp;গীতিকা।**  
**চোখ মেলে দেখি,&nbsp;&nbsp;&nbsp;অশ্রুসাগরে,**  
**সবকিছু&nbsp;&nbsp;&nbsp;&nbsp;মরীচিকা।**

</div>
</div>

জার্মান দার্শনিক, যুক্তিবিদ লুডভিগ উইটগেনস্টাইন লিখেছেন: মানুষের জীবন এক স্বপ্ন। সারা জীবন আমরা থাকি আধো-ঘুমের আবছায়ায় আচ্ছন্ন হয়ে। কেবল ক্ষণিকের জন্য জেগে উঠে টের পাই যে এতক্ষণ আমরা নিদ্রামগ্ন ছিলাম। কিন্তু মুহূর্তের মধ্যেই আবার ঘুমের ঘোরে তলিয়ে যাই। 

উইটগেনস্টাইন সত্যিই এটি বলেছেন কিনা, তা আমি নিশ্চিত নই; তবে অতীতে উপনিষদ, গৌতম বুদ্ধ থেকে শুরু করে শেক্সপিয়ার কিংবা রবীন্দ্রনাথের চিন্তায় এই ভাবটি বারবার ফিরে এসেছে। 

এই যে যেমন অষ্টম শতাব্দীতে গৌড়পাদ রচিত, হিন্দু ও বৌদ্ধ দর্শনে প্রভাবিত মাণ্ডূক্য কারিকা (Māṇḍūkya Kārikā)-গ্রন্থের ২.৩২ নম্বর শ্লোকের নিম্নোক্ত উক্তিটি:

> **সংস্কৃত (देवनागरी):**
> 
> स्वप्ने यथा भ्रमत्येवं जाग्रत्यपि न भिद्यते ।  
> मनःकल्पितमेवैतद्द्वयं हीनाम्शकल्पनम् ॥
> 
> **লিপ্যন্তর:**
> 
> svapne yathā bhramaty evaṁ jāgraty api na bhidyate |  
> manaḥ-kalpitam evaitad dvayaṁ hīnāṁśa-kalpanam ||
> 
> **আক্ষরিক অনুবাদ:**
> 
> যেমন স্বপনে মন নানা দিকে ঘুরে বেড়ায় এবং নানান অভিজ্ঞতার জগৎ সৃষ্টি করে, তেমনই জাগ্রত অবস্থাতেও আসলে কোনো প্রকৃত পার্থক্য নেই। স্বপ্ন ও জাগরণ উভয়ই মনের সৃষ্টি, এই পৃথকতার ধারণা কেবলই ভ্রান্ত কল্পনা।

মানুষের অস্তিত্ব দ্বৈত।

অস্তিত্বের একদিকে রয়েছে মানুষের চিরপ্রসারমান মনস্তাত্ত্বিক জগৎ; সামাজিক ও সাংস্কৃতিক বন্ধনে আবদ্ধ হয়ে যে নিরন্তর নিজেকে অনন্যভাবে তুলে ধরতে চায়, সংগ্রহ করতে চায় ধন, মান, সামাজিক প্রতিষ্ঠা, বীরত্বগাঁথা ইত্যাদি। সেই সামাজিক মানুষের মনের গভীরে এক অভ্যন্তরীণ সংলাপ ক্রমাগত বলে চলে: আমিই শ্রেষ্ঠ। আমার চিন্তা ধারাই সেরা। সবার থেকে আমি আলাদা। সকলের মাঝে আমার অস্তিত্বই সর্বাপেক্ষা গুরুত্বপূর্ণ।   

ক্ষুদ্র পারিবারিক স্তর থেকে শুরু করে বৃহত্তর সামাজিক, রাজনৈতিক এবং মতাদর্শগত পর্যায়ে মানুষের যে বিবিধ আচরণ, তা বেশিরভাগ সময় গভীর কোনো সত্য নয়; বরং পরিচালিত হয় এই অন্ধ প্রবৃত্তি দ্বারা। নিজেকে আলাদা প্রমান করার এবং পরিচয় গঠনের এক মরিয়া প্রয়াসে।

সেই প্রবৃত্তির বশেই মানুষ নিরন্তর নিজের থেকে বৃহত্তর কিছুর সঙ্গে যুক্ত হয়ে তার অস্তিত্বের গুরুত্ব প্রকাশ করতে চায়। বস্তুগত কারণ কম, বরং এমনি কারণেই মানুষ নানান মতাদর্শ, ধর্মীয় বিশ্বাস, ইডিওলজির মতো সামাজিক গঠনকে আঁকড়ে ধরে বাঁচতে চায়।

সে গেল একদিক। 

মানুষের অস্তিত্বের আরেক প্রান্তে রয়েছে তার ভৌত জগৎ — যেখানে সে নিতান্তই শক্তিহীন, রক্ত-মাংসে গড়া এক মরণশীল প্রাণী মাত্র। এই পৃথিবীতে তার স্থান প্রকৃতির ভাঙা-গড়ার নিয়মের পদতলে। সেখানে বিশ্বপ্রকৃতি ঘাত-প্রতিঘাতে তাকে বারবার স্মরণ করিয়ে দেয়: "তোমার অস্তিত্ব আমার কাছে বিশেষ কোনো অর্থ বহন করে না।" 

“তরঙ্গ মিলায়ে যায় তরঙ্গ উঠে, কুসুম ঝরিয়া পড়ে কুসুম ফুটে” — মানুষের হাজার প্রশ্নের উত্তরে মহাবিশ্বের নীরবতা যেন একটি কথাই বলে চলে - "তুমি সমুদ্রের তরঙ্গ কিংবা শিউলি ফুলের মতো আমার বুকে ওঠা ক্ষনিকের একটি স্পন্ধন মাত্র!"

যে বিশ্বে মানুষের জন্ম, সেই বিশ্ব যদি মানুষের কর্মকাণ্ডের প্রতি এমন নির্লিপ্ত থাকে, তবে তা মানুষের মনের পক্ষে গ্রহণ করা কঠিন। এই পৃথিবী যে আমাদের স্থায়ী ঘর নয়—এই উপলব্ধি অস্তিত্বের গভীরে এক অনিবার্য অস্থিরতার জন্ম দেয়। আর যখন সেই অনুভূতি তীব্র হয়ে ওঠে, তখন মনে এক অদ্ভুত গৃহহীনতার বোধ জাগে; যে অনুভূতি বারবার স্বরণ করিয়ে দেয়—সবকিছুই ক্ষণস্থায়ী এক খেলাঘর মাত্র।

আমি মনে করি মৃত্যুকে কেন্দ্র করে অস্তিত্বের গুরুত্ব ঘিরে যে এক দ্বন্দ্বের মধ্য দিয়ে মানুষের বিচরণ, সেই দ্বন্দ্বের যুক্তিযুক্ত সমাধান মানুষের মনের গঠনে এবং সৃজনশীলতার বিকাশে এক গুরুত্বপূর্ণ ভূমিকা পালন করে। বিপরীতে, সেই দ্বন্দ্বের সঠিক সমাধান না-হওয়া সমকালীন সমাজের বহু ব্যাধির মূল উৎস।  

ওপরে লেখা লেখা কবিতাটি অস্তিত্বের দ্বিতীয় পর্যায় নিয়ে; বীরত্ব নয়, সিম্বলিকভাবে নিজেকে গুরুত্বপূর্ণ ভাবার প্রয়াস নয়; বরং মানুষের অস্তিত্বকে স্বপ্নসম করে রাখা মৃত্যুর প্রতি অসহায়তা এবং বাস্তবতার প্রকৃতি সম্পর্কে  বিস্ময় প্রকাশ করেই এই লেখা।

বাংলা ভাষায় পাষান শব্দের অর্থ দুটি: নিষ্ঠুর এবং পাথর। দুটি অর্থই এখানে গুরুত্বপূর্ণ। নিষ্ঠুর পাহাড়ি নদী এখানে সময়, সেই নদীর জল এখানে অশ্রু, ঝর্ণা মৃত্যু, এবং পথে চলতে চলতে গান গাওয়া এখানে সামাজিক সাংস্কৃতিক আঙিনায় আবদ্ধ হয়ে  ক্ষনিকের জন্য গুরুত্বপূর্ণ অনুভব করে ভৌত অস্তিত্বকে মন থেকে মুছে ফেলার ব্যর্থ প্রয়াসের রূপক।  

সুইজারল্যান্ডের সিম্বলিষ্ট আর্টিস্ট বকলিনের “Isle of the Dead” নামের খুব বিখ্যাত একটা চিত্র আছে, যেখানে দেখানো হয়েছে একজন মানুষ নির্জনে নৌকা বেয়ে মৃতদের দ্বীপে ভেসে যাচ্ছে। ২০-লাইনে মানুষের এলিয়েনেটেড অবস্থার তেমনি একটা চিত্র এখানে ফুটিয়ে তুলতে চেষ্টা করলাম; প্রকৃতি থেকে চিহ্ন সংকেত কুড়িয়ে এনে। 

[মূলত মার্কিন সাংস্কৃতিক নৃবিজ্ঞানী আর্নেস্ট বেকার থেকে অনুপ্রাণিত হয়ে লেখা।]`,
  author: "সৌরভ রায়",
  readTime: "৭ মিনিট পড়া",
  category: "Philosophy",
  tags: ["দর্শন", "মৃত্যু", "অস্তিত্ব", "সংস্কৃতি"],
  language: "bengali" as const
};


